import { z } from 'zod'

export const ContactFormSchemaDto = z.object({
  name: z.string().min(1, 'Le nom est requis'),
  indicator: z.string().min(1, "L'indicateur est requis"),
  phone: z.string().min(1, 'Le numéro de téléphone est requis'),
  email: z.email('Email invalide'),
  message: z.string().min(1, 'Le message est requis'),
  recaptchaToken: z.string().min(1, 'Le token reCAPTCHA est manquant.'),
})

export type ContactFormDto = z.infer<typeof ContactFormSchemaDto>
